// import LeaseholdOwnership from './LeaseholdOwnership';
import WIOwnership from '../tract_detail/WIOwnership';
import Owner from '../tract_detail/Owner';
import moment from 'moment';
import IOwner from '../IOwner';
import ProvisionLeaseClause from '../ProvisionLeaseClause';
import LeaseholdClauses from './LeaseholdClauses';

export default class Leasehold {
    id: number;
    ownershipLeaseholdXRefId: number;
    projectId: number;
    clausesId?: number;
    royalty?: number;
    fedStateLeaseNumber: string;
    leaseDate: Date;
    effectiveDate: Date;
    expirationDate: Date;
    poolingOrderNumber: string;
    renewalOption: boolean;
    optionTerm: number;
    optionTermUnits: string;
    optionPricePerAcre: string;
    optionExercised: boolean;
    filedByMemo: boolean;
    recordTypeId: number;
    book: string;
    page: string;
    instrumentNumber: string;
    rentalLease: boolean;
    rentalprice: number;
    priceTypeId: number;
    originalLessee: string;
    originalLessor: string;
    hbp: boolean;
    operator: string;
    wellName: string;
    hbu: boolean;
    apiNumber: string;
    unitName: string;
    fieldName: string;
    totalBonus: number;
    bonusPerAcre: number;
    optionPerAcre: number;
    leaseProgramNotes: string;
    leaseholdOwnerships: Array<WIOwnership>;
    wiOwners: Array<Owner>;
    leaseholdClause: LeaseholdClauses;
    isTopLease: boolean;
    isHistoricalLease: boolean;
    isActiveLease: boolean;
    isRentalLease: boolean;
    attachedFiles?: Array<{ id: number; fileName: string }>;
    status: string;
    ownershipId: number;
    mineralOwner: IOwner;
    primaryTerm: number;
    primaryTermUnits: string;
    notes: string;
    leaseholdClauseId: number;
    lessorAKA: string;
    leaseId: number;
    optionBonusAmount?: number;
    optionBonusAmountUnits?: string;
    optionTotalBonus?: number;
    sourceLeaseholdId?: number;
    horizonNumber?: number;
    tractName?: string;
    provisionalGrossAcres?: number;
    provisionalNetAcres?: number;

    // Not Mapped
    contractLookupId?: number;
    provisionLeaseClauses?: ProvisionLeaseClause[];
    /**
     * Read-only, from LeaseholdDto: whether this leasehold's Lease is in hand. Only set by
     * endpoints that return LeaseholdDto (e.g. the tract leaseholds GET). A leasehold can be
     * isActiveLease with isInHand false — a rough draft nobody executed.
     */
    isInHand?: boolean;

    public static cleanDates(leaseholds: Array<Leasehold>) {
        leaseholds.map((lm: Leasehold) => {
            if (lm?.leaseDate) {
                lm.leaseDate = moment(lm.leaseDate).format('YYYY-MM-DD') as unknown as Date;
            }
            if (lm?.effectiveDate) {
                lm.effectiveDate = moment(lm.effectiveDate).format('YYYY-MM-DD') as unknown as Date;
            }
            if (lm?.expirationDate) {
                lm.expirationDate = moment(lm.expirationDate).format('YYYY-MM-DD') as unknown as Date;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/models/leasehold/Leasehold.ts